import BaseApi from '@/api/controller/base';

const TRANSACTION_API_URL = 'transaction/';

class TransactionApi extends BaseApi {
  constructor() {
    super(TRANSACTION_API_URL);
  }

  get(id) {
    return this.api.get(`${id}`);
  }

  getRelatedEntity(id) {
    return this.api.get(`${id}/relatedEntity`);
  }

  officeBalance(officeId, typeId) {
    return this.api.get('officeBalance', {
      params: {
        office: officeId,
        type: typeId,
      },
    });
  }

  update(transaction) {
    const transactionId = transaction.id;
    if (transactionId) {
      return this.api.post(`${transactionId}`, transaction);
    }
    return Promise.reject(Error('No id specified. Will not update transaction'));
  }

  getGridData(params, query = {}) {
    return this.api.post('gridData', params, {
      params: query,
    });
  }
}

const apiInstance = new TransactionApi();
export { TransactionApi, apiInstance };
export default apiInstance;
